package music.jammers.client.shared.component.member.info.legend.presentation.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.error_dialog_ok
import limasoul.client.shared.generated.resources.event_member_legend_not_required
import limasoul.client.shared.generated.resources.event_member_legend_optional
import limasoul.client.shared.generated.resources.event_member_legend_required
import limasoul.client.shared.generated.resources.event_member_legend_title
import music.jammers.client.shared.component.member.info.legend.di.MemberInfoDIComponent
import music.jammers.client.shared.component.optionalInstrumentColor
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun MemberInfoLegendDialog(extended: Boolean) {
    val viewModel = remember { MemberInfoDIComponent().memberInfoDialogViewModel }

    AlertDialog(
        title = {
            Text(text = stringResource(Res.string.event_member_legend_title))
        },
        text = {
            LegendContent(extended)
        },
        onDismissRequest = { viewModel.onDismissClicked() },
        confirmButton = {
            TextButton(
                onClick = { viewModel.onDismissClicked() },
            ) {
                Text(stringResource(Res.string.error_dialog_ok))
            }
        },
    )
}

@Composable
private fun LegendContent(forAdmin: Boolean) {
    val items = if (forAdmin) {
        listOf(
            MaterialTheme.colorScheme.primary to Res.string.event_member_legend_required,
            optionalInstrumentColor to Res.string.event_member_legend_optional,
            MaterialTheme.colorScheme.surface to Res.string.event_member_legend_not_required,
        )
    } else {
        listOf(
            MaterialTheme.colorScheme.primary to Res.string.event_member_legend_required,
            optionalInstrumentColor to Res.string.event_member_legend_optional,
        )
    }

    Column {
        items.forEach { item ->
            RowContent(item.first, item.second)
            Spacer(modifier = Modifier.size(8.dp))
        }
    }
}

@Composable
private fun RowContent(color: Color, text: StringResource) {
    Row(
        modifier = Modifier.fillMaxWidth(),
    ) {
        Box(
            modifier = Modifier.size(20.dp).background(
                color = color,
                shape = CircleShape
            )
        )

        Spacer(modifier = Modifier.size(4.dp))

        Text(
            text = stringResource(text),
            style = MaterialTheme.typography.bodyLarge,
            modifier = Modifier.align(Alignment.CenterVertically),
        )
    }
}